<template>
  <div class="header-search">
    <b-form-input
      autocomplete="off"
      @blur="clearSearch"
      placeholder="Пошук користувачів"
      v-model="query"
    >
    </b-form-input>
    <b-spinner
      variant="primary"
      v-if="isLoading"
      class="header-search__spinner"
      small
    ></b-spinner>
    <div class="header-search__results" v-show="results.length">
      <div class="result-item" v-for="r in results" :key="r.path">
        <router-link :to="{ name: 'admin-user-single', params: { id: r.id } }">
          <h5 class="name" v-html="r.first_name + ' ' + r.last_name"></h5>
          <div class="email" v-html="r.email"></div>
          <div class="tags d-flex">
            <span
              :style="{
                background:
                  getTagInfo(t) && getTagInfo(t).color
                    ? getTagInfo(t).color.hex
                    : '#66',
              }"
              class="tag"
              v-for="t in r.tags"
              :key="t"
            >
              {{ getTagInfo(t).name }}
            </span>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import algoliasearch from "algoliasearch/lite";
export default {
  data() {
    return {
      isLoading: false,
      query: "",
      searchClient: algoliasearch(
        "17P16OK60L",
        "415df89403ab804abcb694c2b8c42e37"
      ),
      hits: [],
      tags: [],
      delayTimer: null,
    };
  },
  watch: {
    $route: {
      handler() {
        this.clearSearch();
      },
    },
    query: {
      handler() {
        if (this.query.length >= 3) {
          this.doSearch();
        }
        if (this.query.length > 3) {
          this.hits = [];
        }
      },
    },
  },
  computed: {
    results() {
      let results = this.hits.map((el) => {
        let item = {};
        for (var key in el._highlightResult) {
          item[key] = el._highlightResult[key].value;
        }
        return item;
      });

      return results;
    },
  },
  methods: {
    clearSearch() {
      setTimeout(() => {
        this.query = "";
        this.hits = [];
      }, 400);
    },
    doSearch() {
      clearTimeout(this.delayTimer);
      this.delayTimer = setTimeout(async () => {
        this.isLoading = true;
        let index = this.searchClient.initIndex("houses");

        const result = await index.search(this.query);
        let hits = result.hits;
        this.hits = hits;
        console.log(hits);
        this.isLoading = false;
      }, 600);
    },
  },
  mounted() {
    // this.fetchTags();
  },
};
</script>
<style lang="scss">
.result-item {
  em {
    color: var(--primary-color);
    background: rgba(var(--secondary-color-rgb), 0.2);
    display: inline-block;
    font-style: normal;
  }
}
</style>
<style lang="scss" scoped>
.header-search {
  position: relative;
  &__spinner {
    position: absolute;
    right: 10px;
    z-index: 10;
    top: 50%;
    transform: translateY(-50%);
  }
  &__results {
    position: absolute;
    top: calc(100% + 5px);
    z-index: 100;
    background: #fff;
    border-radius: 8px;
    border: 1px solid #e7e7e7;
    box-shadow: 0px 10px 20px 0px rgba(#000, 0.2);
    width: 100%;
    max-height: 520px;
    overflow-y: scroll;
    .result-item {
      padding: 6px 12px;
      border-bottom: 1px solid #e7e7e7;
      .tags {
        .tag {
          color: #fff;
          font-size: 12px;
          padding: 2px 6px;
          line-height: 1;
          border-radius: 4px;
          margin: 3px;
          margin-left: 0;
          text-shadow: 0px 0px 4px rgba(#000, 0.3);
        }
      }
      &:hover {
        background: rgba(var(--primary-color-rgb), 0.1) !important;
      }
      a {
        color: initial;
        text-decoration: none !important;
      }
      &:last-child {
        border-bottom: none;
      }
      width: 100%;
      .name {
        margin: 0;
        font-size: 16px;
      }
      .email {
        font-size: 14px;
        color: #666;
      }
    }
  }
  input {
    background: darken(#e8eaed, 5%);
    border-radius: 6px;
    box-shadow: none !important;
    outline: none !important;
    border: none !important;
    @media (min-width: 768px) {
      width: 400px;
    }
    max-width: 100%;
    transition: 0.3s;
    height: 42px;
    &:focus {
      background: #fff;
      transition: 0.3s;
      box-shadow: 0px 0px 0px 2px var(--primary-color),
        0px 6px 8px 0px rgba(#000, 0.2) !important;
    }
  }
}
</style>
